import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { getProduct } from "@/data/content";

export default function BundleBanner() {
  const family = getProduct("jinsu-family-paketti");
  if (!family) return null;

  return (
    <section data-testid="bundle-banner-section" className="py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Link
          to={`/tuote/${family.slug}/`}
          data-testid="family-banner"
          className="group grid overflow-hidden rounded-[2.5rem] bg-primary shadow-2xl shadow-primary/25 md:grid-cols-2"
        >
          <div className="flex flex-col justify-center p-10 md:p-14 text-primary-foreground">
            <p className="eyebrow text-primary-foreground/60">Paras arvo</p>
            <h3 className="h-section font-heading mt-4 font-semibold" lang="fi">
              Family-paketti
            </h3>
            <p className="mt-4 max-w-md text-base leading-relaxed text-primary-foreground/80">
              2 suihkusuodatinta + 2 vitamiinisuodatinta – koko perheen suihkuvedet kerralla kuntoon.
            </p>
            <div className="mt-7 flex flex-wrap items-center gap-4">
              <span className="text-3xl font-extrabold">{family.priceLabel}</span>
              <span className="text-lg text-primary-foreground/55 line-through">89,60 €</span>
              <span className="rounded-full bg-white/15 px-3.5 py-1.5 text-xs font-extrabold">
                Säästät 15 %
              </span>
            </div>
            <span className="mt-9 inline-flex w-fit items-center gap-2.5 rounded-full bg-white px-7 py-3.5 text-sm font-bold text-primary transition-transform duration-200 group-hover:scale-[1.04]">
              Katso paketti <ArrowRight size={17} />
            </span>
          </div>
          <div className="relative min-h-72 md:min-h-96">
            <img
              src="/images/clean-4.jpg"
              alt="Jinsu Family-paketti – neljä suodatinta"
              loading="lazy"
              className="absolute inset-0 h-full w-full object-cover"
            />
          </div>
        </Link>
      </div>
    </section>
  );
}
